<template>
    <LayoutGradient :title="pageTitle" icon="fa-file-signature">
        <template v-slot:headerRight>
        <b-btn variant="outline-info" @click="$router.back()">
            <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
        </template>
        <b-card class="m-3 mt-n10">
            <SimpleForm :fields="fields" :model="model" @submit="onSubmit" class="tipo-form">
                <template #submitButton>
                    <b-button variant="success" type="submit" >
                        <i class="fas fa-save"/> {{ $t('tipo.form.fields.botao_salvar') }}
                    </b-button>
                </template>
            </SimpleForm>
        </b-card>
    </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TypeRepository from '@/repositories/dexpara/Type/TypeRepository';
import {mapActions, mapGetters} from "vuex";
import SimpleForm from "@/components/FormGenerator/SimpleForm";

export default {
    name: "Form",
    components: {LayoutGradient, SimpleForm},
    data() {
        return {
            tipo_id: null,
            fields: [
                {
                    label: this.$t('tipo.form.fields.nome.label'),
                    name: 'name',
                    description: this.$t('tipo.form.fields.nome.description'),
                },
                {
                    label: this.$t('tipo.form.fields.codigo.label'),
                    name: 'code',
                    description: this.$t('tipo.form.fields.codigo.description'),
                },
                {
                    label: this.$t('tipo.form.fields.status.label'),
                    type: 'checkbox',
                    name: 'status',
                    description: this.$t('tipo.form.fields.status.description'),
                },
            ],
            model: {
                id: null,
                code: '',
                name: '',
                status: false,
            },
        }
    },
    computed: {
        ...mapGetters({
            tipo: 'type/current',
            isLoading: 'type/isLoading'
        }),
        pageTitle() {
            if (this.tipo_id) return this.$t('tipo.form.titulo_pagina.editar')
            return this.$t('tipo.form.titulo_pagina.criar')
        }
    },
    methods: {
        ...mapActions([
            'type/listOne'
        ]),
        async onSubmit(evt) {
            if (this.$route.params.id) {
                this.update()
            } else {
                this.create()
            }
        },
        create() {
            TypeRepository.post(this.model).then(() => {
                this.$snotify.success(this.$t('tipo.form.create.success'))
                this.$router.push({name: 'tipo'})
            }).catch(error => {
                this.$snotify.error(this.$t('tipo.form.create.error'))
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        },
        update() {
            TypeRepository.put(this.tipo_id, this.model).then(() => {
                this.$snotify.success(this.$t('tipo.form.update.success'))
                this.$router.push({name: 'tipo'})
            }).catch(error => {
                this.$snotify.error(this.$t('tipo.form.update.error'))
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        }
    },
    async mounted() {
        this.$store.commit('type/setCurrent', {status: false})
        if (this.$route.params.id) {
            this.tipo_id = this.$route.params.id
            await this['type/listOne'](this.$route.params.id)
            this.model = {
                ...this.model,
                ...this.tipo.data.type,
                status: !!this.tipo.data.type.status || false
            }
        }
    },
}
</script>
